(function () {

  angular
    .module('meanApp')
    .directive('recipeCard', recipeCard);

    function recipeCard () {
        return {
            scope: {
                recipe : '=',
                isdetailedview : '@'
            },
            restrict: 'EA',
            templateUrl: '/common/directives/recipe/recipe.card.template.html',
            replace: true,
            controller: 'recipeCardCtrl as subVm'/**,
            link: function(scope, element, attrs){
                console.log('attributes of the directive are', attrs);
                scope.isDetailedView = 'isDetailedView' in attrs;
            }**/
        };
    }

})();